
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.836 2H4.75A1.75 1.75 0 003 3.75v13c0 .966.784 1.75 1.75 1.75h11a1.75 1.75 0 001.75-1.75V7.664a1.75 1.75 0 00-.512-1.237l-3.915-3.915A1.75 1.75 0 0011.836 2zM4.75 3.5h7.086a.25.25 0 01.176.073l3.915 3.915a.25.25 0 01.073.176v9.086a.25.25 0 01-.25.25h-11a.25.25 0 01-.25-.25v-13a.25.25 0 01.25-.25z"}}),_c('path',{attrs:{"d":"M11.75 2a.75.75 0 01.743.648l.007.102v4a.25.25 0 00.193.243L12.75 7h4a.75.75 0 01.102 1.493l-.102.007h-4a1.75 1.75 0 01-1.744-1.606L11 6.75v-4a.75.75 0 01.75-.75zM7.594 5.688a2.23 2.23 0 011.866.879.75.75 0 01-1.12.99l-.074-.082a.748.748 0 00-.641-.288c-.384 0-.625.18-.625.282 0 .09.19.242.502.275l.123.007c1.133 0 2.122.742 2.122 1.78s-.99 1.782-2.095 1.781a2.233 2.233 0 01-1.865-.878.75.75 0 011.12-.992l.073.083a.75.75 0 00.642.288c.384 0 .625-.181.625-.282 0-.1-.239-.28-.622-.28C6.49 9.25 5.5 8.507 5.5 7.469c0-1.039.99-1.782 2.094-1.781z"}}),_c('path',{attrs:{"d":"M7.625 9.813a.75.75 0 01.743.648l.007.102v.687a.75.75 0 01-1.494.102l-.006-.102v-.687a.75.75 0 01.75-.75zm0-4.813a.75.75 0 01.743.648l.007.102v.687a.75.75 0 01-1.494.102l-.006-.102V5.75a.75.75 0 01.75-.75zm6.625 6.5a.75.75 0 01.102 1.493L14.25 13h-4a.75.75 0 01-.102-1.493l.102-.007h4zm0 3a.75.75 0 01.102 1.493L14.25 16h-7.5a.75.75 0 01-.102-1.493l.102-.007h7.5z"}})])
          )
        }
      }
    